import { createAsyncThunk } from '@reduxjs/toolkit'
import CuratedSeriesList from './curated-series-list-model'
import {
  delete_curatedSeriesList,
  load_curatedSeriesLists,
  store_curatedSeriesList,
} from './curatedSeriesList-service'

export const LoadCuratedSeriesListsAsync = createAsyncThunk<any, any>(
  'composer/load/curatedSeriesList',
  async (params: { uid: string }) => {
    return await load_curatedSeriesLists(params)
  },
)

export const CreateCuratedSeriesListAsync = createAsyncThunk<any, any>(
  'composer/create/curatedSeriesList',
  async (params: CuratedSeriesList) => {
    return await store_curatedSeriesList(params)
  },
)

export const DeleteCuratedSeriesListAsync = createAsyncThunk<any, any>(
  'composer/delete/curatedSeriesList',
  async (params) => {
    return await delete_curatedSeriesList(params)
  },
)
